import { _ as _defineProperty } from './defineProperty-Y-S4SptN.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-w3bsUgPa.js';
import classNames from 'classnames';
import { a as PopperEvent, P as Popper } from './Popper-ckd24nO1.js';
import createUseStyles from './create/index.js';
import { FontSizes, FontWeights } from './fonts/index.js';
import { j as jsxRuntimeExports } from './jsx-runtime-KJzvSKZ_.js';

var useStyles = createUseStyles({
  overlay: {
    backgroundColor: 'var(--backgrounds-tint-1)',
    border: function border() {
      return '1px solid var(--backgrounds-tint-2)';
    },
    padding: 8,
    borderRadius: 8,
    color: 'var(--texts-base)',
    boxShadow: '0px 0px 4px var(--shadows-tint-1)',
    fontSize: FontSizes.Size_4,
    fontWeight: FontWeights.Medium
  }
}, {
  name: 'pa-uiLib-tooltip'
});

var _excluded = ["children", "overlay", "enableArrow", "trigger", "offset", "className", "overlayBorderColor"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultOffset = [0, 12];
function Tooltip(_ref) {
  var children = _ref.children,
    overlay = _ref.overlay,
    _ref$enableArrow = _ref.enableArrow,
    enableArrow = _ref$enableArrow === void 0 ? true : _ref$enableArrow,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? PopperEvent.Hover : _ref$trigger,
    offset = _ref.offset,
    className = _ref.className,
    _ref$overlayBorderCol = _ref.overlayBorderColor,
    overlayBorderColor = _ref$overlayBorderCol === void 0 ? 'var(--backgrounds-tint-3)' : _ref$overlayBorderCol,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles({
    overlayBorderColor: overlayBorderColor
  });
  return /*#__PURE__*/jsxRuntimeExports.jsx(Popper, _objectSpread({
    content: /*#__PURE__*/jsxRuntimeExports.jsx("div", {
      className: classNames(styles.overlay, className),
      children: overlay
    }),
    target: children,
    trigger: trigger,
    enableArrow: enableArrow,
    arrowColor: "#313132",
    offset: offset || defaultOffset
  }, props));
}

export { Tooltip as T };
//# sourceMappingURL=Tooltip-mQqB3TNx.js.map
